$(document).ready(checkContainerr);
$(".centerstone--option.options input").on("change", function () {
  var get = $(this).val();
  console.log(get);
  if (get == "Use your own diamond.") {
    $(".centerstone--option.options .label-option span").hide();
    $(".shape--option.options").find("input").attr("disabled", "disabled");
    $("a.opt--without-diamond").trigger("click");
  } else {
    $(".shape--option.options").find("input").removeAttr("disabled");
    $(".centerstone--option.options .label-option span").show();
    $("a.opt--with-diamond").trigger("click");
  }
});
function checkContainerr() {
  if ($("p.affirm-as-low-as").is(":visible")) {
    //if the container is visible on the page
    var left = $("span.was-price.theme-money").width();
    left = parseFloat(left) + parseInt(8);
    left = "-" + left + "px";
    console.log(left + "left");

    $("p.affirm-as-low-as").css({ "margin-left": left });
  } else {
    //console.log("not found");
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
  }
}
$(document).ready(function () {
  $("a.opt--with-diamond").trigger("click");
  //   $("input#use-your-diamond").change(function(){
  //     if($(this).is(':checked')){
  //       $(".custom-button--for--diamond").find(".loader").show();
  //       $(".custom-button--for--diamond").find("span.labe-text").hide();
  //      $(".shape--option.options").find("input").attr("disabled", "disabled");
  //       $("a.opt--without-diamond").trigger("click");
  //       //$("button.shopify-payment-button__more-options").trigger("click");
  //       // alert("redirecting to checkout");
  //       setTimeout(function(){
  //       $.ajax({
  //         type:"POST",
  //         url:"/cart/add.js",
  //         data:$(".product-purchase-form").serialize(),
  //         dataType:'json',
  //         success:function(response){
  //           $(".custom-button--for--diamond").find(".loader").hide();
  //           $(".custom-button--for--diamond").find("span.labe-text").text("Redirecting to Checkout...");
  //           $(".custom-button--for--diamond").find("span.labe-text").show();
  //           window.location.href = "/checkout/";
  //         }
  //       })
  //         }, 3000);
  // } else {
  //      $(".shape--option.options").find("input").removeAttr("disabled");
  //       $("a.opt--with-diamond").trigger("click");
  // }
  //   })
  var shape = $(".shape--option.options").find("input:checked").val();
  var color = $(".color--option.options").find("input:checked").val();
  var band = $(".band--option.options").find("input:checked").val();
  console.log(shape + "-" + color + "-" + band);
  var final = shape + "-" + color + "-" + band;
  $(".theme-imgd:not([id-img='" + final + "'])").hide();
  //console.log(".theme-img[id-img='"+final+"']");
  $(".theme-imgd[emplty-alt='alt']").show();
  $(".theme-imgd[id-img='" + final + "']").show();
  $(".theme-imageiper-wrapper.mobile_slider_main.cs-p").slick("slickUnfilter");
  $(".theme-imageiper-wrapper.mobile_slider_main.cs-p")
    .slick(
      "slickFilter",
      ".theme-img[id-img='" + final + "'], .theme-img[emplty-alt='alt']"
    )
    .slick("refresh");
  $(".css-utesj a").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(
      "https://calendly.com/capucelli",
      "popupWindow",
      "width=600,height=600,scrollbars=yes"
    );
  });
  $(".window-pop a").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(
      "https://calendly.com/capucelli",
      "popupWindow",
      "width=600,height=600,scrollbars=yes"
    );
  });
  $(".selector-wrapper  select").on("change", function () {
    var get = $(this).val();
    console.log(get);
    $(this)
      .parents(".selector-wrapper ")
      .find("span.cc-swatches__label")
      .text(get);
  });

  //   var span = $(".slider--icon .opt-item");
  // for (var i = 0; i < span.length;  i+=2) {
  //   var div = $("<div/>", {
  //       class: 'each--2'
  //   });
  //   span.slice(i, i+2).wrapAll("<div class='grid--2'><div class='inside-2'></div></div>");
  // }
  $(".css-1nclza4").on("click", function () {
    $("span.svg.rotate-here").toggleClass("rotate-this");
    $(this).toggleClass("rotate-bt");
  });
  $(".css-vd8jt0.inline-mail a").click(function () {
    if ($("iframe#ShopifyChat").length) {
      let iframe = $("iframe#ShopifyChat");

      //find button inside iframe
      let button = iframe.contents().find("button.chat-toggle");

      //trigger button click
      button.trigger("click");
    }
    if ($("iframe#dummy-chat-button-iframe").length) {
      // button.trigger("click");
      let iframe1 = $("iframe#dummy-chat-button-iframe");

      //find button inside iframe
      let button1 = iframe1.contents().find("button#dummy-chat-button");

      //trigger button click
      button1.trigger("click");
    }
    if ($("#AppleBusinessChat").length) {
      $("#AppleBusinessChat").find("#abc-button").find("a").trigger("click");
      window.open(
        $("#AppleBusinessChat").find("#abc-button a").attr("href"),
        "_blank"
      );
    }
    //$('#AppleBusinessChat').find("#abc-button a").trigger("click");
    // location.href($('#AppleBusinessChat').find('#abc-button a').attr("href"));
    //window.open($('#AppleBusinessChat').find('#abc-button a').attr("href"),"_blank")
  });
  $(".custom-product-info-meta .options").each(function () {
    var get = $(this).find("input:checked").val();
    $(this).find("span.option-selected-label").text(get);
  });
  $(".opt-item input").on("change", function () {
    var get = $(this).val();
    $(this).parents(".options").find("span.option-selected-label").text(get);
    var shape = $(".shape--option.options").find("input:checked").val();
    var color = $(".color--option.options").find("input:checked").val();
    var band = $(".band--option.options").find("input:checked").val();
    console.log(shape + "-" + color + "-" + band);
    var final = shape + "-" + color + "-" + band;
    $(".theme-imgd:not([id-img='" + final + "'])").hide();
    //console.log(".theme-img[id-img='"+final+"']");
    $(".theme-imgd[id-img='" + final + "']").show();
    $(".theme-imageiper-wrapper").slick("slickUnfilter");
    $(".theme-imageiper-wrapper")
      .slick("slickFilter", ".theme-img[id-img='" + final + "']")
      .slick("refresh");
  });
  $(".btn-type").on("click", function () {
    $("body").addClass("logo-items-pop");
    $(this).parents(".popup-main").find(".modal--popup").show();
  });
  $(".close-pp").click(function () {
    $("body").removeClass("logo-items-pop");
    $(this).parents(".popup-main").find(".modal--popup").hide();
  });
  var find = $(".collection__active-filter-item").text();
  if (find == "" || find == undefined) {
    $(".filter--block.false.stoneshape li:first-child input").trigger("click");
    setTimeout(function () {
      $(".filter--block.false.color li:first-child input").trigger("click");
    }, 4000);
  }
  $("button.checkout-with-mount").click(function () {
    e.preventDefault();
    e.stopPropagation();
  });
  $("button.select-your-diamond").click(function (e) {
    // e.preventDefault();
    // e.stopPropagation();

    var ptitle = $(
      "h1.product-area__details__title.product-detail__gap-sm.h2"
    ).text();
    var shape = $(".shape--option.options input:checked").val();
    var color = $(".color--option.options input:checked").val();
    var band = $(".band--option.options input:checked").val();
    var ring_size = $(".ring--option.options select").val();

    var c_b_r = $(".custom-bnd--option.options input").val();
    if (ring_size != "" && c_b_r != "") {
      $(".modal-popup").show();
    }
    $("input.product-title").val(ptitle);
    $("input.shape-info").val(shape);
    $("input.color-info").val(color);
    $("input.band-info").val(band);
    $("input.ring-size-info").val(ring_size);
    $("input.cust-band-ring").val(c_b_r);
    e.preventDefault();
    e.stopPropagation();
  });
  $("span.close").click(function () {
    $(".modal-popup").hide();
  });
});
$(document).ready(function () {
  var arrval = [];
  var count = $(".custom-line-item .custom--value-add").length;

  $("li.item.clearfix").each(function () {
    var count = $(this).find(".custom-line-item .custom--value-add").length;
    if (count > 0) {
      var find = $(this).find(".custom-line-item .custom--value-add").text();
      var p_title = $(this).find("span.product-title").text();
      console.log(find);
      arrval.push(find + " - " + p_title);
    }
  });

  console.log(arrval);
  if (count > 0) {
    // $("p.note-area textarea#note").val(arrval);
  }
  $("input#custom-value-top").on("input", function () {
    $("input#custom-value").val($(this).val());
  });
});
$(document).ready(checkContainer);

function checkContainer() {
  if ($(".edt-p").is(":visible")) {
    //if the container is visible on the page
    $("input.edt-product").remove();
    $(".edt-p").hide();
    //console.log("removed");
  } else {
    //console.log("not found");
    setTimeout(checkContainer, 50); //wait 50 ms, then try again
  }
}
$(".desktop_menu_main a.site-nav__link.site-nav__link--main").click(
  function () {
    $(this)
      .parents("li")
      .nextAll("li")
      .find("a")
      .find("img")
      .removeClass("top");
    $(this)
      .parents("li")
      .prevAll("li")
      .find("a")
      .find("img")
      .removeClass("top");
    $(this).parent().find("img").toggleClass("top");

    $(this).parents("li").nextAll("li").find("a").removeClass("active");
    $(this).parents("li").prevAll("li").find("a").removeClass("active");
    $(this).toggleClass("active");

    $(this)
      .parents("li")
      .nextAll("li")
      .find(".site-nav__dropdown.critical-hidden")
      .removeClass("active_menu");
    $(this)
      .parents("li")
      .prevAll("li")
      .find(".site-nav__dropdown.critical-hidden")
      .removeClass("active_menu");
    $(this)
      .parent()
      .find(".site-nav__dropdown.critical-hidden")
      .toggleClass("active_menu");

    //   $(this).parent().find('.site-nav__dropdown.critical-hidden').toggleClass("active_menu");
    //     $(this).parent().find('.site-nav__dropdown.critical-hidden').toggleClass("active_menu");

    //    $(".desktop_menu_main li.site-nav--has-dropdown a").removeClass("active");

    $(
      ".desktop_menu_main li.site-nav--has-dropdown .site-nav__dropdown.critical-hidden"
    ).slideUp("fast");
    $(
      ".desktop_menu_main li.site-nav--has-dropdown .site-nav__dropdown.critical-hidden.active_menu"
    ).slideDown();
  }
);

$(window).scroll(function () {
  if ($(this).scrollTop() > 0) {
    $("div#shopify-section-header").addClass("hide-search-scroll");
  } else {
    $("div#shopify-section-header").removeClass("hide-search-scroll");
  }
  //    if ($(this).scrollDown() > 1) {
  //        $('div#shopify-section-header').addClass('hide-search-scroll');
  //     } else {
  //        $('div#shopify-section-header').removeClass('hide-search-scroll');
  //     }
});

// $('.theme-images.swiper-wrapper').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: '.slider-nav'
// });
// $('.product-area__details__thumbs__thumb').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   asNavFor: '.theme-images.swiper-wrapper',
//   dots: true,
//   centerMode: true,
//   focusOnSelect: true
// });
$(document).ready(function(){
  

$(".theme-imageiper-wrapper").slick({
  dots: true,
  infinite: true,
  draggable: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  navigation: true,
  prevArrow:
    '<div class="arrow-left ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></div>',
  nextArrow:
    '<div class="arrow-right ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></div>'
});
  })

// $('.theme-imageiper-wrapper').slick({
//   infinite: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//     draggable: true,
//    dots: true,
//   arrows: false,
//   speed: 300,
//   autoplay: false
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 1008,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 800,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     }

//   ]
//      });

$(document).ready(function () {
  // Change the main image whenever a thumbnail button is activated
  // $('.carousels').on('init', function(e, slider) {
  //   $(slider.$slides.find('a')).each(function(index) {
  //     $(this).on('click', function() {
  //       // Move aria-current="true" to this button
  //       $(slider.$slides.find('a').removeAttr('aria-current'));
  //       $(this).attr('aria-current', true);

  //       // Change the main image to match this thumbnail button
  //       var index = $(this).closest('.slick-slide').data('slick-index');
  //       $('.theme-images').slick('slickGoTo', index);
  //     });
  //   });
  // });

  // Initialize the slider
  $(".slider--icon").slick({
    slidesToShow: 10,
    infinite: false,
    draggable: true,
    arrows: true,
    prevArrow:
      '<div class="arrow-left ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8px" height="14px" viewBox="0 0 8 14" role="img"><defs></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-2.000000, 1.000000)"><polyline stroke="#5E7A7D" transform="translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) " points="2 0 10 6.12020513 2 12"></polyline></g></svg></div>',
    nextArrow:
      '<div class="arrow-right ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8px" height="14px" viewBox="0 0 8 14" role="img"><defs></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-2.000000, 1.000000)"><polyline stroke="#5E7A7D" transform="translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) " points="2 0 10 6.12020513 2 12"></polyline></g></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(
    ".filter--block.false.stoneshape ul.no-bullets.tag-list.tag-list--active-tags"
  ).slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 1,
    prevArrow:
      '<div class="arrow-left ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8px" height="14px" viewBox="0 0 8 14" role="img"><defs></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-2.000000, 1.000000)"><polyline stroke="#5E7A7D" transform="translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) " points="2 0 10 6.12020513 2 12"></polyline></g></svg></div>',
    nextArrow:
      '<div class="arrow-right ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="8px" height="14px" viewBox="0 0 8 14" role="img"><defs></defs><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-2.000000, 1.000000)"><polyline stroke="#5E7A7D" transform="translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) " points="2 0 10 6.12020513 2 12"></polyline></g></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // $('.carousels').slick({
  //   vertical: true,
  //   slidesToShow: 15,
  //   infinite: true,
  //   draggable: true,
  //   arrows:false,
  //   instructionsText: 'This carousel contains a column of small thumbnails. Selecting a thumbnail will change the main image in the carousel that follows. Use the Previous and Next buttons to cycle through all the thumbnails, use Enter to select.',
  //   regionLabel: 'thumbnails carousel'
  // });

  /********************
    Main image slider
  *********************/
  // $('.theme-images').slick({
  //   slidesToShow: 1,
  //   draggable: true,
  //   arrows:true,
  //   navigation: true,
  //   prevArrow: '<div class="arrow-left ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></div>',
  //   nextArrow: '<div class="arrow-right ls-svg-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></div>',
  //   instructionsText: 'This carousel shows one large product image at a time. Use the Previous and Next buttons to move between images, or use the preceding thumbnails carousel to select a specific image to display here.',
  //   regionLabel: 'main image carousel',
  // });

  // Update the thumbnail slider when the user changes the main slider directly.
  // $('.theme-images').on('beforeChange', function(e, slider, currentSlide, nextSlide) {
  //   // Remove aria-current from the last selected thumbnail image button
  //   $('.carousels a[aria-current="true"]').removeAttr('aria-current');

  //   // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
  //   $('.carousels').slick('slickGoTo', nextSlide);

  //   // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
  //   $('.carousels a:eq(' + nextSlide + ')').attr('aria-current', true);
  // });
});
$(document).ready(function () {
  if ($(window).width() < 768) {
    $(".instagram_main").remove();
  }
  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1; // 👈️ months are 0-based
  const newMonth = date.getMonth() + 2;
  // 👇️ Current Month
  const daysInCurrentMonth = getDaysInMonth(currentYear, currentMonth);
  console.log(daysInCurrentMonth);
  console.log(newMonth);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const d = new Date();
  let monthname = months[d.getMonth() + 1];
  console.log(monthname);

  // 👇️ Other Months
  // const daysInJanuary = getDaysInMonth(2025, 1);
  // console.log(daysInJanuary); // 👉️ 31

  // const daysInSeptember = getDaysInMonth(2025, 9);
  // console.log(daysInSeptember); // 👉️ 30
  $("select.original-selector").on("change", function () {
    var vprice = $(this).find("option:selected").attr("pr-price");
    var vsku = $(this).find("option:selected").attr("pr-sku");
    $(".price-area.product-detail__gap-sm .current-price.theme-money").text(
      vprice
    );
    $("span.sku__value").text(vsku);
    var get = $(this).find("option:selected").attr("variant-image");
    console.log(get);
    // $(".theme-images.desktop_slider .theme-img").each(function(){
    // var img = $(this).attr("data-full-size");
    //   if ( get == img  )
    //   {
    //     var getindex = $(this).attr("data-slick-index");
    //     $('.theme-images').slick('slickGoTo', getindex);
    //   }

    // })
    ////////////////////mobile slider///////////////////////
    $(".theme-imageiper-wrapper.mobile_slider_main .theme-img").each(
      function () {
        var img = $(this).attr("data-full-size");
        if (get == img) {
          var getindex = $(this).attr("data-slick-index");
          $(".theme-imageiper-wrapper").slick("slickGoTo", getindex);
        }
      }
    );
    var vstock = $(this).find("option:selected").attr("vstock");
    var date = $(this).find("option:selected").attr("date");
    var days = $(this).find("option:selected").attr("days");
    var month = $(this).find("option:selected").attr("month");
    monthname = monthname.substring(0, 3);
    var final = parseInt(days) + parseInt(date);
    if (final > daysInCurrentMonth) {
      var datefinal = final - daysInCurrentMonth;
      if (vstock != "") {
        $(".stock-message").html(
          " <div class='stock-msg--in'>" +
            vstock +
            monthname +
            " " +
            datefinal +
            "</div>"
        );
        vstock = vstock.replace(
          "<svg width='12' height='11' viewBox='0 0 12 11' fill='none' class='sc-cCuFUk euzVCd'><path d='M1 6.35714L4.57143 9.92857L11 1' stroke='black' stroke-linecap='round'></path></svg>",
          ""
        );
        $(".hid-estimatew").val(vstock + monthname + " " + datefinal);
        console.log(vstock + month + " " + final);
      }
    } else {
      if (vstock != "") {
        $(".stock-message").html(
          " <div class='stock-msg--in'>" +
            vstock +
            month +
            " " +
            final +
            "</div>"
        );
        vstock = vstock.replace(
          "<svg width='12' height='11' viewBox='0 0 12 11' fill='none' class='sc-cCuFUk euzVCd'><path d='M1 6.35714L4.57143 9.92857L11 1' stroke='black' stroke-linecap='round'></path></svg>",
          ""
        );
        $(".hid-estimatew").val(vstock + month + " " + final);
        console.log(vstock + month + " " + final);
      }
    }
  });
  // $("button.button.no-hover").on("click", function () {
  //   $("body").toggleClass("on--top");
  // });
});
$(document).ready(function () {
  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  const date = new Date();
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth() + 1; // 👈️ months are 0-based
  const newMonth = date.getMonth() + 2;
  // 👇️ Current Month
  const daysInCurrentMonth = getDaysInMonth(currentYear, currentMonth);
  const daysinnextmonth = getDaysInMonth(currentYear, newMonth);
  console.log(daysInCurrentMonth);
  console.log(daysinnextmonth);
  console.log(newMonth);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
  ];

  const d = new Date();
  let monthname = months[d.getMonth() + 1];
  console.log(monthname);
  var vstock = $("select.original-selector")
    .find("option:selected")
    .attr("vstock");
  var datee = $("select.original-selector")
    .find("option:selected")
    .attr("date");
  var days = $("select.original-selector").find("option:selected").attr("days");
  var month = $("select.original-selector")
    .find("option:selected")
    .attr("month");
  monthname = monthname.substring(0, 3);
  var final = parseInt(days) + parseInt(datee);
  console.log(final + "--" + daysInCurrentMonth + "--" + monthname);
  if (final > daysInCurrentMonth) {
    var datefinal = final - daysInCurrentMonth;
    console.log(datefinal);

    if (vstock != "monthname") {
      $(".stock-message").html(
        " <div class='stock-msg--in'>" +
          vstock +
          monthname +
          " " +
          datefinal +
          "</div>"
      );
      vstock = vstock.replace(
        "<svg width='12' height='11' viewBox='0 0 12 11' fill='none' class='sc-cCuFUk euzVCd'><path d='M1 6.35714L4.57143 9.92857L11 1' stroke='black' stroke-linecap='round'></path></svg>",
        ""
      );

      $(".hid-estimatew").val(vstock + monthname + " " + datefinal);
    }
  } else {
    if (vstock != "") {
      $(".stock-message").html(
        " <div class='stock-msg--in'>" + vstock + month + " " + final + "</div>"
      );
      vstock = vstock.replace(
        "<svg width='12' height='11' viewBox='0 0 12 11' fill='none' class='sc-cCuFUk euzVCd'><path d='M1 6.35714L4.57143 9.92857L11 1' stroke='black' stroke-linecap='round'></path></svg>",
        ""
      );

      $(".hid-estimatew").val(vstock + month + " " + final);
    }
  }
});
// // When the user scrolls the page, execute myFunction
// window.onscroll = function() {myFunction()};

// // Get the header
// var header = document.getElementById("footer--btn");
// var header1 = document.getElementById("footer--btn");
// var form = document.getElementById("FacetsForm");

// // Get the offset position of the navbar
// var sticky = header1.offsetTop;

// // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
// function myFunction() {
//   if (window.pageYOffset > sticky + 400) {
//     header.classList.add("sticky");
//     form.classList.add("sticky-form");
//     $(".wide-container.half-gutter.cc-product-filter-container.pt-0").addClass("remove-padding");
//   } else {
//     header.classList.remove("sticky");
//     form.classList.remove("sticky-form");
//     $(".wide-container.half-gutter.cc-product-filter-container.pt-0").removeClass("remove-padding");

//   }
// }

  // $('.current-price theme-money 1').wrapAll('<div class="child"></div>');









// Custom Ring Script
// $(document).ready(function () {
// // Get Started 1st step
// $(document).on("click", ".letsgetStarted", function () {
//   var selectValue = $(".select__step1").val();
//   if (selectValue == "") {
//     $(".letsget-started").addClass("show-message");
//     $(this)
//       .parents(".customize-ring__start")
//       .find(".customizer-navigation-message")
//       .html(
//         '<span class="error--message">Please select an option to continue</span>'
//       );
//   } else {
//     $(".letsget-started").removeClass("show-message");
//     $(this)
//       .parents(".customize-ring__start")
//       .find(".customizer-navigation-message")
//       .html("");
//     $(this).parents(".cust-step-1").removeClass("active");
//     $(".cust-step-2").addClass("active");
//   }
//   $(".customize-ring__step--selections").slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     prevArrow:
//       '<div class="b-prevArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
//     nextArrow:
//       '<div class="b-nextArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 766,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 650,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 550,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: true,
//         },
//       },
//     ],
//   });
// });
// $(document).on("click", ".customize-ring__step--selection", function () {
//   $(this).each(function () {
//     var multipleValue = $(this).attr("data-title");
//     if ($(this).parents().hasClass("multiple-selection")) {
//       $(this).toggleClass("active-selection");
//       if (
//         $(this).parents(".multiple-selection").find(".active-selection")
//           .length > 0
//       ) {
//         $('input[name="contact[Stone Type]"]').val(multipleValue);
//       } else {
//         $('input[name="contact[Stone Type]"]').val("");
//       }
//     } else {
//       $(this).addClass("active-selection");
//       $('input[name="contact[Stone Shape]"]').val(multipleValue);
//       $(this).siblings().removeClass("active-selection");
//       $(this)
//         .parents(".cust-step-4")
//         .find('input[name="contact[Setting]"]')
//         .val(multipleValue);
//       $(this)
//         .parents(".cust-step-5")
//         .find('input[name="contact[Precious Metal]"]')
//         .val(multipleValue);
//     }
//   });
// });
// $(document).on("click", ".customizer-navigation__next", function () {
//   $(this)
//     .parents(".customize-ring__step")
//     .find(".step--field")
//     .each(function () {
//       var inputValue = $(this).val();
//       if (inputValue == "") {
//         $(this)
//           .parents(".customize-ring__step")
//           .find(".customizer-navigation-message")
//           .addClass("show-message")
//           .html(
//             '<span class="error--message">Please select an option to continue</span>'
//           );
//       } else {
//         $(this)
//           .parents(".customize-ring__step")
//           .find(".customizer-navigation-message")
//           .removeClass("show-message")
//           .html("");
//         $(this).parents(".customize-ring__step").removeClass("active");
//         $(this).parents(".customize-ring__step").next().addClass("active");
//       }
//     });

//   $(this)
//     .parents(".customize-ring__step")
//     .find(".customize-ring__fields")
//     .each(function () {
//       if (
//         $(this).val() == "" ||
//         $(this).val() != "" ||
//         $(this).is(":checked")
//       ) {
//         $(this).parents(".customize-ring__step").removeClass("active");
//         $(this).parents(".customize-ring__step").next().addClass("active");
//       }
//     });
//   $(this)
//     .parents(".customize-ring__step")
//     .find(".customize-ring__step--selection.active-selection")
//     .each(function () {
//       var dataTitle = $(this).attr("data-title");
//       var dataDesc = $(this).attr("data-description");
//       var dataImage = $(this).attr("data-image");
//       var dataStepTitle = $(this).attr("data-step-title");
//       $(".customize-ring__step--summary").append(
//         '<div class="summary-wrap" data-step-section="' +
//           dataStepTitle +
//           '">' +
//           '<div class="summary-category">' +
//           '<div class="summary-heading">' +
//           dataStepTitle +
//           "</div>" +
//           '<img src="' +
//           dataImage +
//           '">' +
//           "</div>" +
//           '<div class="summary-content">' +
//           '<div class="summary-info">' +
//           '<div class="summary-info--title">' +
//           dataTitle +
//           "</div>" +
//           '<div class="summary-info--description">' +
//           dataDesc +
//           "</div>" +
//           "</div>" +
//           "</div>" +
//           '<div class="summary-action"></div>' +
//           "</div>"
//       );
//     });
//   if ($(this).parents(".customize-ring__step").hasClass("cust-step-7")) {
//     $(this).parents(".customize-ring__step").removeClass("active");
//     $(this).parents(".customize-ring__step").next().addClass("active");
//   }

//   if ($(this).parents(".customize-ring__step").hasClass("cust-step-6")) {
//     var ringSize = $('input[name="contact[Ring Size]"]').val();
//     var budgetRing = "";
//     $('input[name="contact[Budget]"]').each(function () {
//       if ($(this).is(":checked")) {
//         budgetRing += $(this, ":checked").val();
//       }
//     });
//     var textAreaValue = $('textarea[name="contact[Additional Notes]"]').val();
//     var uploadFile = $(".inputfile").val();
//     var fileNumber = $(".custom-design-upload").length;
//     var addInfoHtml = "";
//     if (ringSize != "") {
//       addInfoHtml +=
//         '<div class="summary-info">' +
//         '<div class="summary-info--title">Size</div>' +
//         '<div class="summary-info--description">' +
//         ringSize +
//         "</div>" +
//         "</div>";
//     }
//     if (budgetRing != "") {
//       addInfoHtml +=
//         '<div class="summary-info">' +
//         '<div class="summary-info--title">Budget</div>' +
//         '<div class="summary-info--description">' +
//         budgetRing +
//         "</div>" +
//         "</div>";
//     }
//     if (textAreaValue != "") {
//       addInfoHtml +=
//         '<div class="summary-info">' +
//         '<div class="summary-info--title">Additional Notes</div>' +
//         '<div class="summary-info--description">' +
//         textAreaValue +
//         "</div>" +
//         "</div>";
//     }
//     if (fileNumber != 0) {
//       addInfoHtml +=
//         '<div class="summary-info">' +
//         '<div class="summary-info--title">Attachment</div>' +
//         '<div class="summary-info--description">' +
//         "<span>Attached File (" +
//         fileNumber +
//         ")</span>" +
//         "</div>" +
//         "</div>";
//     }
//     if (
//       ringSize != "" ||
//       budgetRing != "" ||
//       textAreaValue != "" ||
//       fileNumber != 0
//     ) {
//       $(".customize-ring__step--summary").append(
//         '<div class="summary-wrap" data-step-section="Additional Info">' +
//           '<div class="summary-category">' +
//           '<div class="summary-heading">Additional Info</div>' +
//           '<img src="https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png">' +
//           "</div>" +
//           '<div class="summary-content">' +
//           "" +
//           addInfoHtml +
//           "" +
//           "</div>" +
//           '<div class="summary-action"></div>' +
//           "</div>"
//       );
//     }
//   }

//   $(".customize-ring__step--selections").slick("refresh");

//   $(".customize-ring__step--selections").slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     prevArrow:
//       '<div class="b-prevArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
//     nextArrow:
//       '<div class="b-nextArrow"><img src="https://cdn.shopify.com/s/files/1/0105/6289/5930/files/next-arrow.webp?v=1683701526"></div>',
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 766,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 650,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2,
//           dots: true,
//         },
//       },
//       {
//         breakpoint: 550,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: true,
//         },
//       },
//     ],
//   });
// });

// $(document).on("click", 'input[name="contact[Budget]"]', function () {
//   if ($(this).is(":checked")) {
//     $(this).attr("checked", "checked");
//   }
// });
// $(document).on("change", "#customizer-attachment-file", function () {
//   var files = $("#customizer-attachment-file")[0].files;
//   console.log(files);
//   var fd = new FormData();
//   if (files.length > 0) {
//     fd.append("file", files[0]);
//     $.ajax({
//       url: "https://upbrighterservices.com/capucelli/upload.php",
//       type: "post",
//       data: fd,
//       dataType: "json",
//       contentType: false,
//       processData: false,
//       beforeSend: function () {
//         $(".s-upload__button").html("Loading....");
//       },
//       success: function (response) {
//         console.log(response)
//         var extension = response.extension;
//         var path = response.path;
//         var id = response.id;
//         var imageName = response.upload_image;
//         $(".s-upload__button").html("Add Image");
//         $(".upload--file").append(
//           '<span class="custom-design-upload">' +
//             '<input type="hidden" name="image_id" value="' +
//             id +
//             '">' +
//             '<input type="hidden" name="image_name" value="' +
//             imageName +
//             '">' +
//             '<span class="image-cross">X</span>' +
//             '<img src="https://upbrighterservices.com/capucelli/' +
//             path +
//             '"></span>'
//         );
//         $("#customizer-attachment-file").val("");
//       },
//     });
//   }
//   else{
//     var uploadFile = $(".inputfile").val();
//     var fileNumber = $(".custom-design-upload").length;
//      var addInfoHtml =
//         '<div class="summary-info">' +
//         '<div class="summary-info--title">Attachment</div>' +
//         '<div class="summary-info--description">' +
//         "<span>Attached File (" +
//         fileNumber +
//         ")</span>" +
//         "</div>" +
//         "</div>";
    
//     if (uploadFile != "") {
//       $(".customize-ring__step--summary").append(
//         '<div class="summary-wrap" data-step-section="Additional Info">' +
//           '<div class="summary-category">' +
//           '<div class="summary-heading">Additional Info</div>' +
//           '<img src="https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png">' +
//           "</div>" +
//           '<div class="summary-content">' +
//           "" +
//           addInfoHtml +
//           "" +
//           "</div>" +
//           '<div class="summary-action"></div>' +
//           "</div>"
//       );
//   }
//   }
// });
// $(document).on("click", ".image-cross", function () {
//   $(this).each(function () {
//     var deleteId = $(this)
//       .parents(".custom-design-upload")
//       .find('input[name="image_id"]')
//       .val();
//     var deleteImage = $(this)
//       .parents(".custom-design-upload")
//       .find('input[name="image_name"]')
//       .val();
//     $.ajax({
//       url: "https://upbrighterservices.com/capucelli/delete.php",
//       method: "POST",
//       data: { id: deleteId, upload_image: deleteImage },
//       success: function (data) {
//         if ($(".custom-design-upload").length == 0) {
//           $(".inputfile").val("");
//         }
//       },
//     });
//     $(this).parents(".custom-design-upload").remove();
//   });
// });
// // $(document).on("click", "input[type=submit]", function () {
// //   if (
// //     $(this)
// //       .parents(".customize-ring__step")
// //       .find('input[name="contact[name]"]')
// //       .val() != "" &&
// //     $(this)
// //       .parents(".customize-ring__step")
// //       .find('input[name="contact[email]"]')
// //       .val() != ""
// //   ) {
// //     $(this).parents(".customize-ring__step").removeClass("active");
// //     $(".customize-ring__success").addClass("active");
// //   }
// // });

// $(document).on("click", ".customizer-navigation__prev", function () {
//   $(this).parents(".customize-ring__step").removeClass("active");
//   $(this).parents(".customize-ring__step").prev().addClass("active");
//   $(".customize-ring__step--selections").slick("refresh");
//   $(this).each(function () {
//     if ($(this).parents(".customize-ring__step").hasClass("cust-step-7")) {
//       $(this)
//         .parents(".customize-ring__step")
//         .find('.summary-wrap[data-step-section="Additional Info"]')
//         .remove();
//     } else if (
//       $(this).parents(".customize-ring__step").hasClass("cust-step-6")
//     ) {
//       $('.summary-wrap[data-step-section="Precious Metal"]').remove();
//     } else if (
//       $(this).parents(".customize-ring__step").hasClass("cust-step-5")
//     ) {
//       $('.summary-wrap[data-step-section="Setting"]').remove();
//     } else if (
//       $(this).parents(".customize-ring__step").hasClass("cust-step-4")
//     ) {
//       $('.summary-wrap[data-step-section="Stone Shape"]').remove();
//     } else if (
//       $(this).parents(".customize-ring__step").hasClass("cust-step-3")
//     ) {
//       $('.summary-wrap[data-step-section="Stone Type"]').remove();
//     } else {
//     }
//   });
// });

// $(document).on("click", ".summary-action", function () {
//   var dataStep = $(this)
//     .parents(".summary-wrap")
//     .find(".summary-heading")
//     .text();
//   $(".customize-ring__step--selections").slick("refresh");
//   $(".customize-ring__step").each(function () {
//     if ($(this).attr("data-step-title") == dataStep) {
//       $(this).addClass("active");
//       $(".cust-step-7").removeClass("active");
//     }
//   });
//   if (
//     $(this).parents(".summary-wrap").find(".summary-heading").text() ==
//     "Stone Type"
//   ) {
//     $(this).parents(".customize-ring__step--summary").html("");
//   } else {
//     $(this)
//       .parents(".summary-wrap")
//       .prev(".summary-wrap")
//       .nextAll(".summary-wrap")
//       .remove();
//   }
// });
//   });


